/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const SCAN_EVENT_DETAIL: Record<
  Redux.EventType,
  {
    key: Redux.EventType
    name: string
  }
> = {
  malicious: {
    key: 'malicious',
    name: 'Malicious Events',
  },
  error: {
    key: 'error',
    name: 'Scan Error Events',
  },
}
export const SCAN_EVENT_KEYS: Redux.EventType[] = Object.keys(
  SCAN_EVENT_DETAIL
) as Redux.EventType[]
